export function getTotalTimeInSecs(date: Date | number): number {
	if (typeof date === 'number') {
		date = new Date(date);
	}

	return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
}
